import React from "react"

const SectionHeader = ({ title, className = "" }) => (
  <h2
    className={`has-text-centered text-dark-blue is-size-2-desktop is-size-2-mobile is-size-2-tablet has-text-weight-semibold ${className}`}
  >
    {title}
  </h2>
)

export default SectionHeader
